import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-image-preview',
  templateUrl: './image-preview.component.html',
  styleUrls: ['./image-preview.component.less']
})
export class ImagePreviewComponent implements OnInit {
  @Input() imgSrc: string;
  @Output() closeEvent = new EventEmitter();
  constructor() { }
  ngOnInit() {
  }

  close() {
    this.closeEvent.emit();
  }

}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/shared/image-preview/image-preview.component.ts